import type { IMenuData } from "@/components/TabBar/index.d";
import { NO_MENUS_URLS } from "@/constants";
import { getMenus } from "@/service/account";
import { useMount, useRequest } from "ahooks";
import { useMemo } from "react";
import { useHistory } from "react-router-dom";

interface IOptions {
  source?: string;
  onSuccess?: () => void;
}

export default function useTabMenus(options?: IOptions) {
  const { source, onSuccess } = options ?? {};
  const history = useHistory();

  const hasMenuBar = useMemo(() => {
    if (source && source !== "app") {
      return false;
    }
    if (NO_MENUS_URLS.includes(history.location.pathname.toLowerCase())) {
      return false;
    }
    return true;
  }, [history.location.pathname, source]);

  const { data, run: fetchMenus } = useRequest<IMenuData>(getMenus, {
    manual: true,
    onSuccess,
  });

  useMount(() => {
    if (hasMenuBar) {
      fetchMenus();
    }
  });

  return {
    menus: data?.data?.menu,
    hasMenuBar,
  };
}
